import { GridColDef } from '@mui/x-data-grid';
import { RslDimension } from '../../../api/schema';
import { SignificanceIcon } from '@components/shared/SignificanceIcon';
import { formatters } from '@utils/formattersV2';

const STATISTICALLY_SIGNIFICANT_COLUMN = {
  field: 'statisticallySignificant',
  headerName: '',
  display: 'flex',
  flex: 0.2,
  minWidth: 40,
  renderCell: ({ row }) => (
    <SignificanceIcon
      status={row.statisticallySignificant ? 'significant' : 'insignificant'}
    />
  ),
} as const satisfies GridColDef<Pick<RslDimension, 'statisticallySignificant'>>;

const DIMENSION_VALUE_COLUMN = {
  field: 'dimensionValue',
  headerName: 'Dimension',
  display: 'flex',
  flex: 1,
  minWidth: 150,
} as const satisfies GridColDef<Pick<RslDimension, 'dimensionValue'>>;

const IMPRESSIONS_COLUMN = {
  field: 'impressions',
  headerName: 'Impressions',
  display: 'flex',
  flex: 1,
  minWidth: 150,
  type: 'number',
  valueFormatter: value => formatters.impressions(value, { full: true }),
} as const satisfies GridColDef<Pick<RslDimension, 'impressions'>>;

const UNIQUE_USERS_COLUMN = {
  field: 'uniqueUsers',
  headerName: 'Unique Users',
  display: 'flex',
  flex: 1,
  minWidth: 150,
  type: 'number',
  valueFormatter: value => formatters.users(value, { full: true }),
} as const satisfies GridColDef<Pick<RslDimension, 'uniqueUsers'>>;

export const sharedColumns = {
  statisticallySignificant: STATISTICALLY_SIGNIFICANT_COLUMN,
  dimensionValue: DIMENSION_VALUE_COLUMN,
  impressions: IMPRESSIONS_COLUMN,
  uniqueUsers: UNIQUE_USERS_COLUMN,
} as const;
